import { Zap } from "lucide-react";

const sizes = {
  sm: { box: "h-8 w-8", zap: "h-4 w-4", text: "text-xl", radius: "rounded-lg" },
  md: { box: "h-10 w-10", zap: "h-5 w-5", text: "text-2xl", radius: "rounded-xl" },
  lg: { box: "h-12 w-12", zap: "h-6 w-6", text: "text-3xl", radius: "rounded-xl" },
};

export const LogoMark = ({ size = "md" }) => {
  const s = sizes[size] || sizes.md;
  return (
    <span className={`relative flex ${s.box} items-center justify-center ${s.radius} border border-emerald-500/60 bg-[#0b120e] shadow-[0_0_16px_rgba(16,185,129,0.35)]`}>
      <Zap className={`${s.zap} text-emerald-400`} fill="currentColor" strokeWidth={1.25} />
    </span>
  );
};

export const Logo = ({ size = "md", className = "" }) => {
  const s = sizes[size] || sizes.md;
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <span className={`font-display ${s.text} font-extrabold tracking-tight text-white`}>
        crazy<span className="text-emerald-400">One</span>
      </span>
    </span>
  );
};
